export const VNPPI_SERVICES = {
  REPORT_ORDER: 'reportOrder',
  GET_BALANCE: 'getBalance',
  GET_CONTEXTUAL_BALANCE: 'getContextualBalance',
  GET_CONTEXTUAL_DISCOUNTS: 'getContextualDiscounts',
  GET_DISCOUNTS: 'getDiscounts',
}

export const VNPPI_TENDERS = {
  GIFTCARD_TENDER: 'GIFTCARD_TENDER',
  TICKET_TENDER: 'TICKET_TENDER',
  QRPAY_TENDER: 'QRPAY_TENDER',
}

export const VNPPI_TENDERS_KEY = {
  GIFTCARD_TENDER: 'vnapi_giftcard',
  TICKET_TENDER: 'vnapi_ticket',
  QRPAY_TENDER: 'vnapi_qrpay',
}

export const VNPPI_REPORT = {
  ALL: 'ALL',
  PARTIAL: 'PARTIAL',
}

export const VNPPI_PAYMENT_SETUP = {
  SINGULAR: 'SINGULAR', // used when we combine getDiscounts + getBalance in a singular payment transaction
}
